import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { JobSelectors } from '../../../store/job/selectors'
import { FlexRow } from '../../atoms/layout/Flex'
import { JobArea } from '../../../types/job'
import Label from '../../atoms/display/Label'

type Props = {
  areaIds: string[]
  highlightAreaIds: string[]
}

function isHighlight(highlightAreaIds: string[], areaId: string, areaMap: { [key: string]: JobArea }) {
  if (highlightAreaIds.includes(areaId)) {
    return true
  }
  const area = areaMap[areaId]
  if (area == null) {
    return false
  }
  return area.children.some((child) => highlightAreaIds.includes(child.id))
}

function AreaName(props: {
  areaId: string
  areaIds: string[]
  areaMap: { [key: string]: JobArea }
  parentAreaIds: { [key: string]: string }
  highlightAreaIds: string[]
}) {
  const { areaId, areaIds, areaMap, parentAreaIds, highlightAreaIds } = props
  const parentAreaId = parentAreaIds[areaId]
  if (parentAreaId && areaIds.includes(parentAreaId)) {
    return null
  }
  const parentArea = Object.values(parentAreaIds).includes(areaId)
  const suffix = parentArea ? '全域' : ''
  const highlight = isHighlight(highlightAreaIds, areaId, areaMap)

  return (
    <Box bgcolor={highlight ? '#fdd835' : undefined} px={0.5}>
      <Label text={`${areaMap[areaId]?.name ?? ''}${suffix}`} />
    </Box>
  )
}

export default function CompanyWorkAreasView({ areaIds, highlightAreaIds }: Props) {
  const areas = useSelector(JobSelectors.areas)
  const areaMap: { [key: string]: JobArea } = {}
  const parentAreaIds: { [key: string]: string } = {}
  areas.forEach((area) => {
    areaMap[area.id] = area
    area.children.forEach((child) => {
      areaMap[child.id] = child
      parentAreaIds[child.id] = area.id
    })
  })

  if (areaIds.length === 0) {
    return (
      <Box px={0.5}>
        <Label text="未設定" />
      </Box>
    )
  }

  return (
    <FlexRow wrap>
      {areaIds.map((areaId) => (
        <AreaName
          key={areaId}
          areaId={areaId}
          areaIds={areaIds}
          areaMap={areaMap}
          parentAreaIds={parentAreaIds}
          highlightAreaIds={highlightAreaIds}
        />
      ))}
    </FlexRow>
  )
}
